import type { ManagementUser } from '@efdigital/ll-admin-v2/data/builders/users/find-user';
import Component from '@glimmer/component';

interface Signature {
  Args: {
    profile: ManagementUser;
  };
}

export default class UserAccessSection extends Component<Signature> {
  get customLoginFlagsLabel(): string {
    switch (this.args.profile.customLoginFlags) {
      case 'IgnoreSSO':
        return 'Ignore SSO';
      case 'NoSetPassword':
        return 'No set password';
      default:
        return 'Default';
    }
  }

  <template>
    <div class="card mb-4" data-test-user-access>
      <div class="card-header">
        <h2 class="h5 mb-0">Access</h2>
      </div>
      <div class="card-body">
        <dl class="row mb-4">
          <dt class="col-sm-3">Login flags</dt>
          <dd class="col-sm-9 mb-3">{{this.customLoginFlagsLabel}}</dd>

          <dt class="col-sm-3">Analytics</dt>
          <dd class="col-sm-9 mb-3">
            {{#if @profile.excludeFromAnalytics}}
              <span class="text-danger"><iconify-icon
                  inline
                  icon="ph:warning"
                />
                Excluded from analytics</span>
            {{else}}
              Included in analytics
            {{/if}}
          </dd>

          <dt class="col-sm-3">Rights</dt>
          <dd class="col-sm-9 mb-3">
            {{#if @profile.rights.length}}
              <div class="d-flex flex-wrap gap-1">
                {{#each @profile.rights as |right|}}
                  <span class="badge text-bg-light border">{{right}}</span>
                {{/each}}
              </div>
            {{else}}
              <span class="text-body-secondary">No rights assigned</span>
            {{/if}}
          </dd>
        </dl>
      </div>
    </div>
  </template>
}
